import { IImportVO } from 'library/ts/interfaces/importer/IImportVO';

/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Dependency import object
 */
export class ImportVO implements IImportVO {

	/**
	 * @description ImportVO order in array
	 */
	order: number | string | any = NaN;

	/**
	 * @description Import type css or js
	 */
	type: string;

	/**
	 * @description URL of dependency import
	 * @type {string}
	 */
	url: string;

	/**
	 * @description Object to check (in String format)<br>
	 * i.e. <code>'my.namespace.method'</code>
	 */
	namespace: string;

	/**
	 * @description Location to check for objectString existence<br>
	 * i.e. <code>window</code>
	 */
	location: any;

	/**
	 * @description Attributes that should be applied to script or style import
	 */
	attributes: Record<string, unknown> | any;

	/**
	 * @description Category of import i.e. 'smarttag:dependency', 'view:plugin'
	 */
	category: string;

	/**
	 * @description Name fo class-owner of this import. The one instantiating the class
	 */
	owner: string;

	/**
	 * @description Flag indicating that import object already exists on a page...
	 */
	exists: boolean = false;

	/**
	 * @description Flag indicating that import has failed
	 */
	failed: boolean = false;

	/**
	 * @description Import loading event
	 */
	event: Event;

	/**
	 * @param {string} type
	 * @param {string} url
	 * @param {string} namespace
	 * @param location
	 * @param {Record<string, unknown> | any} attributes
	 * @param {string} category
	 * @param {string} owner
	 */
	constructor(
		type: string,
		url: string,
		namespace: string = undefined,
		location: any = window,
		attributes: Record<string, unknown> | any = undefined,
		category: string = undefined,
		owner: string = undefined
	) {
		this.type = type;
		this.url = url;
		this.namespace = namespace;
		this.location = location;
		this.attributes = attributes;
		this.exists = false;
		this.failed = false;
		this.event = undefined;
		this.category = category;
		this.owner = owner;
	}

	get name(): string {
		return 'ImportVO';
	}

}